import React from "react"
import PropTypes from "prop-types"
import { useStaticQuery, graphql } from "gatsby"
import Fade from "react-reveal/Fade"
import Box from "../base/Box"
import Text from "../base/Text"
import Heading from "../base/Heading"
import Container from "../UI/Container"
import { FeatureItem, FeatureButton, FeatureContainer } from "./hosting.style"
import ShapeOne from "../../assets/images/shapes/shape-1.svg"
import ShapeTwo from "../../assets/images/shapes/shape-2.svg"
import ShapeThree from "../../assets/images/shapes/shape-3.svg"
import ShapeFour from "../../assets/images/shapes/shape-4.svg"
import ShapeFive from "../../assets/images/shapes/shape-5.svg"
import { SectionText, SectionHeading } from "../Section/Section"

const FeatureSection = ({
  sectionWrapper,
  row,
  col,
  secTitleWrapper,
  featureItemHeading,
  featureItemDes,
}) => {
  const Data = useStaticQuery(graphql`
    query {
      dataJson {
        FEATURES_DATA {
          title
          icon
          description
        }
      }
    }
  `)

  const { FEATURES_DATA } = Data.dataJson

  return (
    <FeatureContainer {...sectionWrapper}>
      <Container>
        <Box {...secTitleWrapper}>
          <Fade bottom cascade>
            <SectionText content="Nos Services" />
            <SectionHeading content="Nous sommes rapides et efficaces." />
          </Fade>
        </Box>

        <Box {...row} className="boxServiceContainer">
          {FEATURES_DATA.map((featureItem, index) => (
            <Box {...col} key={`feature-${index}`} className="myService">
              <Fade bottom delay={index * 240}>
                <FeatureItem
                  title={
                    <Heading
                      {...featureItemHeading}
                      content={featureItem.title}
                    />
                  }
                  description={
                    <Text
                      {...featureItemDes}
                      content={featureItem.description}
                    />
                  }
                  icon={<i className={featureItem.icon} />}
                  additionalContent={
                    <>
                      <img
                        className="hover-shape-1 hover-shape"
                        src={ShapeOne}
                        alt="Shape One"
                      />
                      <img
                        className="hover-shape-2 hover-shape"
                        src={ShapeTwo}
                        alt="Shape Two"
                      />
                      <img
                        className="hover-shape-3 hover-shape"
                        src={ShapeThree}
                        alt="Shape Three"
                      />
                      <img
                        className="hover-shape-4 hover-shape"
                        src={ShapeFour}
                        alt="Shape Four"
                      />
                      <img
                        className="hover-shape-5 hover-shape"
                        src={ShapeFive}
                        alt="Shape Five"
                      />
                    </>
                  }
                  button={
                    index === FEATURES_DATA.length - 1 ? (
                      <FeatureButton
                        title={
                          <i className="flaticon-next">{` prendre rendez-vous`}</i>
                        }
                      ></FeatureButton>
                    ) : null
                  }
                />
              </Fade>
            </Box>
          ))}
        </Box>
      </Container>
    </FeatureContainer>
  )
}

FeatureSection.propTypes = {
  sectionWrapper: PropTypes.object,
  secTitleWrapper: PropTypes.object,
  row: PropTypes.object,
  col: PropTypes.object,
  secHeading: PropTypes.object,
  secText: PropTypes.object,
  featureItemHeading: PropTypes.object,
  featureItemDes: PropTypes.object,
}

FeatureSection.defaultProps = {
  sectionWrapper: {
    as: "section",
    pt: ["60px", "80px", "80px", "80px"],
    pb: ["60px", "80px", "80px", "80px"],
    id: "feature_section",
  },
  secTitleWrapper: {
    mb: ["50px", "60px"],
  },
  secText: {
    as: "span",
    display: "block",
    textAlign: "center",
    fontSize: "14px",
    letterSpacing: "0.15em",
    fontWeight: "700",
    color: "rgb(255,148,147)",
    mb: "10px",
  },
  secHeading: {
    textAlign: "center",
    fontSize: ["20px", "24px"],
    fontWeight: "400",
    color: "#0f2137",
    letterSpacing: "-0.025em",
    mb: "0",
  },
  row: {
    flexBox: true,
    flexWrap: "wrap",
    ml: "-15px",
    mr: "-15px",
  },
  col: {
    className: "col",
    width: [1, 1 / 2, 1 / 3, 1 / 3],
    pr: "15px",
    pl: "15px",
    mb: "30px",
  },
  featureItemHeading: {
    fontSize: ["18px", "18px", "16px", "20px"],
    fontWeight: "400",
    color: "#0f2137",
    lineHeight: "1.5",
    mb: ["10px", "10px", "10px", "10px"],
    letterSpacing: "-0.020em",
    maxWidth: ["auto", "auto", "auto", "180px"],
  },
  featureItemDes: {
    fontSize: ["14px", "14px", "14px", "15px"],
    lineHeight: "1.75",
    color: "#343d48cc",
    mb: ["20px", "20px", "20px", "20px"],
  },
}

export default FeatureSection
